import React from "react";
import "../../styles/aboutus.css";

const AboutUs = () => {
  return (
    <div className="conatiner about-content mx-auto">
      <div className="row about-heading">
        <h2 className="about-main-heading">About Us</h2>
      </div>
      <div className="row">
        <div className="about-paragraph">
          <p>
            <h3 className="p-5">
              Adhering to this and keeping this in mind we proudly present to
              you I.S.T.E (Indian Society for Technical Education) is a
              national, professional, non-profit making, government aided
              society, started in 1941 as the "Association of Principals of
              Technical Education (A.P.T.I)". With its SRM Chapter's inception
              in 2007 it has grown to become the most active technical society
              which is government aided in SRM IST.
            </h3>
            <p>
              <h3 className="sub-heading-about">Introduction</h3>
              Adhering to this and keeping this in mind we proudly present to
              you I.S.T.E (Indian Society for Technical Education) is a
              national, professional, non-profit making, government aided
              society, started in 1941 as the "Association of Principals of
              Technical Education (A.P.T.I)". With its SRM Chapter's inception
              in 2007 it has grown to become the most active technical society
              which is government aided in SRM IST.
              <br />
              <h3 className="sub-heading-about">Our Mission and Vision</h3>
              Similarly our mission is to create a community which uplifts devs
              to unleash their true potential. Skill up! To that end, we will be
              working hard to ensure that we align our actions with that
              purpose. These Community Guidelines should not only help you
              understand how to act within the community but also help you
              understand what to expect from others in this space. Join our
              discord server today and start with your fun learning experience!
            </p>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
